<template>
    <div>  
      <div class="modal fade" id="modalAnotaciones" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-xl">
          <div
            class="modal-content color-scheme-light"
            style="width: 100%; max-width: 100%"
          >
            <div class="modal-header faded smaller">
              <h5 class="text-success modal-title" id="modalAnotacionesLabel">Lista de Anotaciones</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="table-responsive tableFixHead" style="width: 100%;">
                <table class="table table-striped table-bordered table-hover">
                  <thead class="bg-light">
                    <tr>
                      <th>Fecha de creación</th>
                      <th>Número</th>
                      <th>Usuario</th>
                      <th>Observacion</th>
                      <th>Estado</th>
                      <th>Venta</th>
                      <th>Detalles</th>
                    </tr>
                  </thead>
                  <tbody
                    :class="{
                      'loader-wrapper': !anotacionesCargadas,
                    }"
                  >
                    <tr v-if="anotacionesCargadas && anotaciones.length === 0">
                      <td colspan="8">
                        <h6 class="text-center">No hay anotaciones para mostrar.</h6>
                      </td>
                    </tr>
                    <LoaderComponent
                      :condicion="anotacionesCargadas"
                    ></LoaderComponent>
                    <tr v-for="anotacion in anotaciones" :key="anotacion.id">
                      <td>
                        <pre>{{ anotacion.fecha_creacion }}</pre>
                      </td>
                      <td>{{ anotacion.numero }}</td>
                      <td>{{ anotacion.usuario_obj.username }}</td>
                      <td>{{ anotacion.observacion }}</td>
                      <td>{{ anotacion.estado_obj.descripcion }}</td>
                      <td>{{ anotacion.total_venta }}</td>
                      <td>{{ anotacion.total_detalles }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-dark" data-dismiss="modal">
                    <i class="fas fa-door-open"></i> Cerrar
                </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  
  import DynamicService from "@/services/commons/DynamicService"
  import LoaderComponent from "@/components/commons/LoaderComponent.vue";

  export default {

    components: {
      LoaderComponent
    },
    props:{
      corte_tienda_id:{
        type: String,
        default: '',
      },
    },
    data(){
      return {
        anotaciones: [],
        anotacionesCargadas:false,
      }
    },
    mounted(){
      this.refreshAnotaciones();
    },
    methods: {
      refreshAnotaciones(){
        let self = this;
        self.anotacionesCargadas = true;
        self.anotaciones = [];
        let params = {
            quitar_paginacion:true,
            corte_tienda: self.corte_tienda_id,
        };
        DynamicService.fetch(
          "cxc",
          "corte-tienda-anotaciones",
          params
        )
        .then(response => {
          console.log(response.data);
          self.anotaciones = response.data;
          self.anotacionesCargadas = true;
        })

      },
      formatDate(date) {
        return moment(date).format('DD/MM/YYYY HH:mm:ss');
      },
    },
  };
  </script>
  
  <style scoped>
  pre {
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  </style>